export default __webpack_public_path__ + "static/media/gears.8bc867d1.svg";